"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Promise = exports.promise = void 0;
const react_1 = __importStar(require("react"));
const widget_1 = require("../basics/widget");
const promise = (p, options) => (i) => (0, widget_1.fromJSX)((setState) => (react_1.default.createElement(exports.Promise, { key: options === null || options === void 0 ? void 0 : options.key, promise: () => p(i), onFulfilled: setState, onRejected: (reason) => {
        if (options && options.on_fail)
            setState(options.on_fail(reason));
    } })));
exports.promise = promise;
const Promise = (props) => {
    (0, react_1.useEffect)(() => {
        props.promise().then(props.onFulfilled, (reason) => {
            console.log('The promise failed for the following reason:');
            console.log(reason);
            props.onRejected(reason);
        });
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Promise = Promise;
